<div
	gdColumns="repeat(auto-fill, minmax(250px, 1fr))"
	gdGap="10px"
	[formGroup]="form"
>
	<mat-form-field>
		<input
			matInput
			placeholder="Project Name"
			formControlName="projectName"
		/>
	</mat-form-field>
	<mat-form-field>
		<input
			matInput
			placeholder="Project Number"
			formControlName="projectNumber"
		/>
	</mat-form-field>
	<mat-form-field>
		<input matInput placeholder="City" formControlName="city" />
	</mat-form-field>
	<mat-form-field>
		<input matInput placeholder="County" formControlName="county" />
	</mat-form-field>
	<mat-form-field>
		<input
			matInput
			placeholder="State"
			formControlName="state"
			[matAutocomplete]="state"
			maxlength="2"
		/>
		<mat-autocomplete #state="matAutocomplete">
			<mat-option
				*ngFor="let state of filteredStates$ | async"
				[value]="state"
			>
				{{ state }}
			</mat-option>
		</mat-autocomplete>
		<mat-error *ngIf="form.get('state').hasError('invalidItem')">
			Must be a valid state from the dropdown list.
		</mat-error>
	</mat-form-field>
	<mat-slide-toggle
		formControlName="certifiedPayrollReportsRequired"
		labelPosition="before"
		class="custom-slider"
		>Certified Payroll Reports Required
	</mat-slide-toggle>
	<mat-form-field>
		<input
			matInput
			placeholder="Payroll Reports Name"
			formControlName="payrollReportsName"
		/>
	</mat-form-field>
	<mat-form-field>
		<input
			[textMask]="phoneMask"
			matInput
			placeholder="Payroll Reports Phone"
			formControlName="payrollReportsPhone"
		/>
		<mat-error>Invalid phone number</mat-error>
	</mat-form-field>
	<mat-form-field>
		<input
			matInput
			placeholder="Payroll Reports Email"
			formControlName="payrollReportsEmail"
		/>
		<mat-error>Invalid email address</mat-error>
	</mat-form-field>
</div>
